import { MutationTree } from 'vuex'
import { mutationType } from './mutation-types'
import PaymentHistoryState, {IPaymentHistory, PaymentHistoryList} from './states'
import _ from 'lodash'
import axios from 'axios'

const completePathFn = process.env.VUE_APP_BASEURL
const mutations: MutationTree<PaymentHistoryState> = {
  [mutationType.GET_LISTS](
    state: PaymentHistoryState,
    data: PaymentHistoryList,
  ): void {
    state.list = data
  },
  [mutationType.GET_BY_ID](
    state: PaymentHistoryState,
    data: IPaymentHistory,
  ): void {
    state.byId = data
  },
  [mutationType.UPDATE](
    state: PaymentHistoryState,
    data: object,
  ): void {
    state.update = data
  },
}

export default mutations
